﻿import type { Chart3DKind } from '../types/chart3d';

interface SuggestionRule {
  kind: Chart3DKind;
  name: string;
  reason: string;
  keywords: string[];
}

const RULES: SuggestionRule[] = [
  { kind: 'line3d', name: '3D 趋势折线', reason: '趋势/时间序列', keywords: ['趋势', '走势', '时间', '折线', 'line', 'trend', '监控'] },
  { kind: 'bar3d', name: '3D 对比柱状', reason: '对比/排名', keywords: ['对比', '比较', '排名', '柱', 'bar', '产量', '销售'] },
  { kind: 'pie3d', name: '3D 占比饼图', reason: '占比/构成', keywords: ['占比', '比例', '构成', '份额', '饼', 'pie', '分布'] },
  { kind: 'donut3d', name: '3D 环形占比', reason: '占比/环形', keywords: ['环形', '甜甜圈', 'donut', '完成率'] },
  { kind: 'gauge3d', name: '3D 指标仪表', reason: 'KPI/达成率', keywords: ['仪表', 'kpi', '达成', '完成率', 'gauge', '指标'] },
  { kind: 'radar3d', name: '3D 多维雷达', reason: '多维评分', keywords: ['雷达', '多维', '评分', '能力', 'radar'] },
  { kind: 'funnel3d', name: '3D 转化漏斗', reason: '转化/流程', keywords: ['漏斗', '转化', '流程', 'funnel', '成交'] },
  { kind: 'scatter3d', name: '3D 相关散点', reason: '相关性/分布', keywords: ['散点', '相关', 'scatter', '分布'] },
  { kind: 'surface3d', name: '3D 曲面地形', reason: '连续场/地形', keywords: ['曲面', '地形', 'surface', '热力'] },
  { kind: 'map3d', name: '3D 区域地图', reason: '区域/地理', keywords: ['地图', '区域', '省份', 'map', '地理'] },
  { kind: 'globe3d', name: '3D 全球地球', reason: '全球/点位', keywords: ['地球', '全球', 'globe', '世界'] },
  { kind: 'graph3d', name: '3D 关系网络', reason: '关系/网络', keywords: ['关系', '网络', '拓扑', '链路', 'graph'] },
];

export function suggestCharts(prompt: string): Array<{ kind: Chart3DKind; name: string; reason: string }> {
  const text = String(prompt || '').toLowerCase();
  const hits = RULES.filter((rule) => rule.keywords.some((keyword) => text.includes(keyword.toLowerCase())));
  const picked = (hits.length ? hits : [RULES[1]]).slice(0, 3);
  return picked.map((rule) => ({ kind: rule.kind, name: rule.name, reason: rule.reason }));
}
